module.exports = __webpack_public_path__ + "ca763c9bef96a629ef9110dca190682a.svg";